'use client';

import { c as _c } from "react/compiler-runtime";
import { type ChangeEvent, useEffect } from 'react';
import type { LocationSelectorProps } from '@/app/components/form-kit/types';
import { Select } from '@/app/components/forms/select';
import { FORM_LABELS, FORM_PLACEHOLDERS } from '@/app/constants/forms';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { safeCall } from '@/app/utils/safeCall';
import { useDealersFromProvinces } from '@/services/lms/useDealersFromProvinces';
export const LocationSelector = t0 => {
  const $ = _c(56);
  const {
    theme: t1,
    formLayout: t2,
    provinces: t3,
    errors,
    required: t4,
    disabled: t5,
    provinceOnly: t6,
    dealerColSpan: t7,
    dealerLabel,
    dealerPlaceholder,
    values,
    setValue,
    registerRef,
    onDealerSelect
  } = t0;
  const theme = t1 === undefined ? "light" : t1;
  const formLayout = t2 === undefined ? "single-column" : t2;
  let t8;
  if ($[0] !== t3) {
    t8 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const provinces = t8;
  const required = t4 === undefined ? false : t4;
  const disabled = t5 === undefined ? false : t5;
  const provinceOnly = t6 === undefined ? false : t6;
  const dealerColSpan = t7 === undefined ? 1 : t7;
  let t9;
  if ($[2] !== setValue || $[3] !== values) {
    t9 = {
      values,
      setValue
    };
    $[2] = setValue;
    $[3] = values;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  const {
    provinceId,
    districtId,
    districts,
    selectedDealer,
    dealers,
    handleProvinceChange,
    handleDistrictChange,
    handleDealerChange
  } = useDealersFromProvinces(provinces, t9);
  let t10;
  let t11;
  if ($[5] !== onDealerSelect || $[6] !== selectedDealer) {
    t10 = () => {
      safeCall(onDealerSelect, selectedDealer);
    };
    t11 = [selectedDealer, onDealerSelect];
    $[5] = onDealerSelect;
    $[6] = selectedDealer;
    $[7] = t10;
    $[8] = t11;
  } else {
    t10 = $[7];
    t11 = $[8];
  }
  useEffect(t10, t11);
  const t12 = formLayout === "two-column";
  const t13 = formLayout !== "two-column";
  let t14;
  if ($[9] !== t12 || $[10] !== t13) {
    t14 = cn({
      "col-span-2 lg:col-span-1": t12,
      "col-span-2": t13
    });
    $[9] = t12;
    $[10] = t13;
    $[11] = t14;
  } else {
    t14 = $[11];
  }
  const groupClassName = t14;
  const t15 = formLayout === "two-column" && dealerColSpan === 1;
  const t16 = formLayout === "two-column" && dealerColSpan === 2;
  const t17 = formLayout !== "two-column";
  let t18;
  if ($[12] !== t15 || $[13] !== t16 || $[14] !== t17) {
    t18 = cn({
      "col-span-2 lg:col-span-1": t15,
      "col-span-2 lg:col-span-2": t16,
      "col-span-2": t17
    });
    $[12] = t15;
    $[13] = t16;
    $[14] = t17;
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  const dealerGroupClassName = t18;
  let t19;
  if ($[16] !== registerRef) {
    t19 = registerRef("province");
    $[16] = registerRef;
    $[17] = t19;
  } else {
    t19 = $[17];
  }
  const t20 = provinceId ?? "";
  let t21;
  if ($[18] !== handleProvinceChange) {
    t21 = e => handleProvinceChange(e.target.value);
    $[18] = handleProvinceChange;
    $[19] = t21;
  } else {
    t21 = $[19];
  }
  let t22;
  if ($[20] !== provinces) {
    t22 = provinces.map(_temp);
    $[20] = provinces;
    $[21] = t22;
  } else {
    t22 = $[21];
  }
  const t23 = !!errors?.province;
  const t24 = errors?.province;
  let t25;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = createDataAttributes({
      test: "province"
    });
    $[22] = t25;
  } else {
    t25 = $[22];
  }
  let t26;
  if ($[23] !== disabled || $[24] !== groupClassName || $[25] !== required || $[26] !== t19 || $[27] !== t20 || $[28] !== t21 || $[29] !== t22 || $[30] !== t23 || $[31] !== t24 || $[32] !== theme) {
    t26 = <Select ref={t19} theme={theme} name="province" required={required} label={FORM_LABELS.province} placeholder={FORM_PLACEHOLDERS.province} value={t20} onChange={t21} options={t22} error={t23} errorMessage={t24} disabled={disabled} groupClassName={groupClassName} {...t25} />;
    $[23] = disabled;
    $[24] = groupClassName;
    $[25] = required;
    $[26] = t19;
    $[27] = t20;
    $[28] = t21;
    $[29] = t22;
    $[30] = t23;
    $[31] = t24;
    $[32] = theme;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== dealerGroupClassName || $[35] !== dealerLabel || $[36] !== dealerPlaceholder || $[37] !== dealers || $[38] !== disabled || $[39] !== districtId || $[40] !== districts || $[41] !== errors?.dealer || $[42] !== errors?.district || $[43] !== groupClassName || $[44] !== handleDealerChange || $[45] !== handleDistrictChange || $[46] !== provinceId || $[47] !== provinceOnly || $[48] !== registerRef || $[49] !== required || $[50] !== selectedDealer?.branchCode || $[51] !== theme) {
    t27 = !provinceOnly && <><Select ref={registerRef("district")} theme={theme} name="district" label={FORM_LABELS.district} placeholder={FORM_PLACEHOLDERS.district} value={districtId ?? ""} onChange={e_0 => handleDistrictChange(e_0.target.value)} options={districts.map(_temp2)} error={!!errors?.district} errorMessage={errors?.district} disabled={disabled || !provinceId} groupClassName={groupClassName} {...createDataAttributes({
        test: "district"
      })} /><Select ref={registerRef("dealer")} theme={theme} name="dealer" required={required} label={dealerLabel ?? FORM_LABELS.dealer} placeholder={dealerPlaceholder ?? FORM_PLACEHOLDERS.dealer} value={selectedDealer?.branchCode ?? ""} onChange={e_1 => handleDealerChange(e_1.target.value)} options={dealers.map(_temp3)} error={!!errors?.dealer} errorMessage={errors?.dealer} disabled={disabled || dealers.length === 0} groupClassName={dealerGroupClassName} {...createDataAttributes({
        test: "dealer"
      })} /></>;
    $[34] = dealerGroupClassName;
    $[35] = dealerLabel;
    $[36] = dealerPlaceholder;
    $[37] = dealers;
    $[38] = disabled;
    $[39] = districtId;
    $[40] = districts;
    $[41] = errors?.dealer;
    $[42] = errors?.district;
    $[43] = groupClassName;
    $[44] = handleDealerChange;
    $[45] = handleDistrictChange;
    $[46] = provinceId;
    $[47] = provinceOnly;
    $[48] = registerRef;
    $[49] = required;
    $[50] = selectedDealer?.branchCode;
    $[51] = theme;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t26 || $[54] !== t27) {
    t28 = <>{t26}{t27}</>;
    $[53] = t26;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  return t28;
};
function _temp(province) {
  return {
    label: province.name_th,
    value: province.uid
  };
}
function _temp2(district) {
  return {
    value: district.uid,
    label: district.name_th
  };
}
function _temp3(dealer) {
  return {
    label: dealer.name_th,
    value: dealer.branchCode
  };
}